<template>
  <a-tooltip v-if="isOverflow" :title="content">
    <div
      ref="textRef"
      class="ellipsis-text"
      :style="{
        width: width ? width + 'px' : 'auto',
        WebkitLineClamp: rows,
      }"
    >
      {{ content }}
    </div>
  </a-tooltip>
  <div
    v-else
    ref="textRef"
    class="ellipsis-text"
    :style="{
      width: width ? width + 'px' : 'auto',
      WebkitLineClamp: rows,
    }"
  >
    {{ content }}
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch, nextTick } from 'vue'

defineOptions({
  name: 'EllipsisText',
})

interface Props {
  content: string | null
  width?: number
  rows?: number
}

const props = withDefaults(defineProps<Props>(), {
  content: null,
  width: 300,
  rows: 1,
})

const textRef = ref<HTMLElement | null>(null)
const isOverflow = ref(false)

const checkOverflow = () => {
  if (textRef.value) {
    const el = textRef.value
    isOverflow.value =
      el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth
  }
}

onMounted(() => {
  nextTick(() => checkOverflow())
})

watch(
  () => props.content,
  () => {
    nextTick(() => checkOverflow())
  }
)
</script>

<style lang="less" scoped>
.ellipsis-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
</style>
